import { CreateCollegeNameAPIResponse, GetCollegeNameAPIResponse } from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/college-name`;

export const getCollegeName = async ({
	page,
	limit,
	search,
	allowedColleges,
}: {
	page?: number;
	limit?: number;
	search?: string;
	allowedColleges?: string;
}): Promise<GetCollegeNameAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}`, {
		params: {
			page,
			limit,
			search,
			allowedColleges,
		},
	});
	return response.data;
};

export const createCollegeName = async ({ name }: { name: string }): Promise<CreateCollegeNameAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/create-college-name`, {
		name,
	});
	return response.data;
};
